import React,{useEffect, useState} from 'react';
import {FaInfoCircle} from 'react-icons/fa'
import TextQuestion from './TextQuestion/TextQuestion';
import ChoiceQuestion from './ChoiceQuestion/ChoiceQuestion';
import SelectQuestion from './SelectQuestion/SelectQuestion';
import PercentQuestion from './PercentQuestion/PercentQuestion';
import NumberQuestion from './NumberQuestion/NumberQuestion';
import CurrencyQuestion from './CurrencyQuestion/CurrencyQuestion';
import DateQuestion from './DateQuestion/DateQuestion';
import PercentDistQuestion from './PercentDistQuestion/PercentDistQuestion';
import ValueUnitsQuestion from './ValueUnitsQuestion/ValueUnitsQuestion';
import Button from '../../Button/Button';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {Block} from '../../../styles/commons';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import PageTransition from '../../PageTransition/PageTransition';
const QuestionEval = require('./QuestionEval/QuestionEval')

const SectionLink = styled(Link)`
  color: #2b68b2;
  transition: 0.4s ease all;

  :hover {
    text-decoration: naddValuesone;
    color: #23b6ea;
  }
`;

const QuestionType = props => {
  const [showInformation, setShowInformation] = useState(false);

  const {
    match:{params:{key}={}}={},
    setQuestionIndex,
    handleAnswer,
    handleMultipleAnswers,
    markValid,
    handleNextLink,
    handleBackLink,
    questionnaire=[],
    answers,
    pathBase
  } = props;

  const questionIndex = questionnaire.findIndex(item => item.key === key);

  useEffect(() => {
    setQuestionIndex(questionIndex);
  },[key, setQuestionIndex, questionIndex]);

  const questionData = questionnaire.find(item => item.key === key);

  function handleChange(value) {
    handleAnswer(key,value);
  };

  const questionProps = {
    ...questionData,
    handleAnswer,
    handleChange,
    handleMultipleAnswers,
    markValid,
    questionKey:key
  };

  const {information} = questionData
  
  if (answers !== undefined && questionData !== undefined && questionData.text !== undefined ) {
    QuestionEval.addValues(answers);

    const newText = QuestionEval.evaluateText(questionData.text)
    questionData.text = newText
  }
  
  const questionTypes = {
    text: <TextQuestion {...questionProps} />,
    choice: <ChoiceQuestion {...questionProps} />,
    select: <SelectQuestion {...questionProps} />,
    percentage: <PercentQuestion {...questionProps} />,
    number: <NumberQuestion {...questionProps} />,
    currency: <CurrencyQuestion {...questionProps} />,
    date: <DateQuestion {...questionProps} />,
    percentdist: <PercentDistQuestion {...questionProps } />,
    valueunit: <ValueUnitsQuestion {...questionProps } />
  };

  const Information = () => {
    return (
      <div
        style={{display:'inline-block'}}
        onMouseEnter={() => setShowInformation(true)}
        onMouseLeave={() => setShowInformation(false)}
      >
        {information &&
          <p style={{color: 'blue'}}><FaInfoCircle size={24}/></p>
        }
      </div>
    )
  }
  
  return (
    <PageTransition loading={!questionData} msg='Loading next question...'>
        <Container>
        <Row>
          <Col lg={2} />
          <Col sm={12} lg={8}>
            {questionData && (
              <Block>
                <Information/>
                {questionTypes[questionData.type]}
                <hr style={{marginTop:'40px'}} />
                <div style={{display:'inline-block',verticalAlign:'top'}}>
                  <SectionLink to={`/${pathBase}`}>Return to Sections</SectionLink>
                </div>
                <div style={{float:'right'}}>
                  {questionIndex > -1 && (
                    <Button
                      click={handleBackLink}
                      grey
                      marginRight='10px'
                    >BACK</Button>
                  )}
                  <Button click={handleNextLink}>NEXT</Button>
                </div>
                <div style={{height:18}} />
              </Block>
            )}
          </Col>
          <Col lg={2} />
          { showInformation && InformationPopup(information) }
        </Row>
      </Container>
    </PageTransition>
  );
};

const InformationWrapper = styled.div`
  width: 300px;
  border-radius: 8px;
  box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.5);
  padding: 15px 10px;
  background: #282F35;
  position: fixed;
  z-index: 7000;
  top: 80px;
  right: 40px;
  color: #fff;
  font-size: 16px;
  white-space: pre-wrap;
`;

const InformationPopup = (information) => (
  <InformationWrapper>
    {information}
  </InformationWrapper>
);

export default QuestionType;
